import { FilterOption, Option } from '../../interfaces';
import {
  OrganizationBusiness,
  OrganizationBusinessService,
} from '../../types/organizations';
import { getArtistName } from '../../utils/global/helper';

export function getOrganizationBusinessOptions(
  businesses: OrganizationBusiness[] | undefined,
): FilterOption[] {
  if (!businesses?.length) return [];
  return businesses.map(business => ({
    label: business.name,
    value: business.businessId,
  }));
}

export function getArtistOptionsFromOrganizationBusiness(
  business: OrganizationBusiness | undefined,
): FilterOption[] {
  if (!business?.employeesToBusinesses?.length) return [];

  return business.employeesToBusinesses
    .filter(etb => etb.isBookable || !!etb.employee.employeesToServices?.length)
    .map(etb => ({
      label: getArtistName(etb.employee as any),
      value: etb.employeeId,
      color: etb.color || undefined,
    }));
}

export function getServiceOptionsFromOrganizationBusiness(
  business: OrganizationBusiness | undefined,
): Option[] {
  const options: Option[] = [{ value: '0', label: 'Tattoo' }];
  if (!business?.services?.length) return options;

  business.services.forEach(service => {
    const existing = options.find(
      option => option.value === String(service.serviceId),
    );
    if (!existing) {
      options.push({
        value: String(service.serviceId),
        label: service.serviceName,
      });
    }
  });
  return options;
}

export function getServiceFromOrganizationBusiness(
  business: OrganizationBusiness | undefined,
  serviceId?: string | number | null,
): OrganizationBusinessService | undefined {
  if (!serviceId) return undefined;
  return business?.services?.find(
    service => String(service.serviceId) === String(serviceId),
  );
}
